import { render, staticRenderFns } from "./TariffList.vue?vue&type=template&id=04ce2c30&scoped=true&"
import script from "./TariffList.vue?vue&type=script&lang=js&"
export * from "./TariffList.vue?vue&type=script&lang=js&"
import style0 from "./TariffList.vue?vue&type=style&index=0&id=04ce2c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce2c30",
  null
  
)

export default component.exports